<header class="page-header">
  <div class="page-header__brand">
    <img class="page-header__logo" src="/logo.png" width="56" height="56" alt="" />
    <div>
      <div class="page-header__row">
        <h1>Data tools</h1>
        <span class="badge">Beta</span>
      </div>
      <p class="lede">
        Privacy-first supervisory reporting utilities. Filing data stays in your browser.
      </p>
    </div>
  </div>
</header>

<div class="tool-grid">
  @for (tool of tools; track tool.path) {
    <a class="tool-card" [routerLink]="tool.path">
      <div class="tool-card__head">
        <h2>{{ tool.title }}</h2>
        @if (tool.badge) {
          <span class="badge">{{ tool.badge }}</span>
        }
      </div>
      <p>{{ tool.description }}</p>
    </a>
  }
</div>
